import React, { useEffect, useState, useRef } from "react";
import {
	FileMetaData,
	FilePreviewContainer,
	FileUploadContainer,
	FormField,
	ImagePreview,
	InputLabel,
	PreviewContainer,
	PreviewList,
	RemoveFileIcon,
	ShowContent,
	UploadFileBtn,
} from "../file-upload/file-upload.styles";
import BaseService from "services/BaseService";
import pdf from "../../../assets/images/pdf.png";
import { getLang } from "helpers/common";
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import CropImg from "./CropImg";

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 50000000;

const FileUpload = ({
	label,
	attachmentType,
	attachmentData,
	updatedAttachment,
	deleteAttachment,
	maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
	setUploadState = () => {},
	ratio,
	...otherProps
}) => {
	const cancelTokenSource = useRef();
	const AuthData = useSelector((state) => state.Auth);
	const { t } = useTranslation();
	const fileInputField = useRef(null);
	const [percent, setPercent] = useState(0);
	const [files, setFiles] = useState([]);
	const [lastAddedFiles, setLastAddedFiles] = useState([]);
	const acceptFileTypes = ["pdf", "doc", "docx"];
	const acceptImageTypes = [
		"jpg",
		"jpeg",
		"png",
		"mp4",
		"PNG",
		"JPG",
		"JPEG",
		"MP4",
	];
	const [cropModal, setCropModal] = useState(false);
	const toggleCrop = () => setCropModal(!cropModal);
	const [fileName, setFileName] = useState(null);
	const [loadingCrop, setLoadingCrop] = useState(false);
	const [imageCrop, setImageCrop] = useState("");

	useEffect(() => {
		let uploadState = percent === 0 ? false : percent === 100 ? false : true;
		setUploadState(uploadState);
	}, [percent]);
	useEffect(() => {
		//if(attachmentData){
		setFiles(attachmentData);
		//}
		return () => {
			cancelTokenSource?.current?.cancel();
		};
	}, [attachmentData]);

	const handleUploadBtnClick = () => {
		fileInputField.current.click();
	};

	const addNewFiles = (newFiles) => {
		let files = [];
		for (let file of newFiles) {
			if (file.size <= maxFileSizeInBytes) {
				if (!otherProps.multiple) {
					return [file];
				}
				files.push(file);
			}
		}
		return files; // [...files]
	};

	const checkType = (src) => {
		const dotIndex = src.lastIndexOf(".");
		const fileType = src.substring(dotIndex + 1, src.length);
		const isFile = acceptFileTypes.findIndex((type) => type === fileType) > -1;
		return isFile;
	};
	const handleNewFileUpload = async (e) => {
		otherProps?.setUpload(true);
		// const { files: newFiles } = [e];
		// if (newFiles.length) {
		// let updatedFiles = addNewFiles(newFiles);
		//TODO enhance if 50 file will send 50 ajax
		let createdFiles = [];
		cancelTokenSource.current = axios.CancelToken.source();
		const options = {
			cancelToken: cancelTokenSource.current.token,
			ignoreInterceptors: true,
			onUploadProgress: (progressEvent) => {
				const { loaded, total } = progressEvent;
				let percentValue = (loaded * 100) / total;
				setPercent((percent) => {
					const value = (percentValue - percent) / 1;
					const updatedPercentage = value + percent;
					if (percent > updatedPercentage) {
						return percent;
					} else {
						return updatedPercentage;
					}
				});
			},
		};
		new BaseService()
			.postUpload(e, options)
			.then((res) => {
				otherProps?.setUpload(false);
				const createdFile = res?.data?.data;
				createdFiles.push(createdFile);
				if (!otherProps.multiple) {
					setFiles(createdFiles);
				} else {
					setFiles([...files, ...createdFiles]);
				}
				setPercent(0);
				setLastAddedFiles(createdFiles);
				setCropModal(false);
			})
			.catch((err) => {
				otherProps?.setUpload(false);
				setPercent(0);
			});
		//}
	};

	useEffect(() => {
		if (lastAddedFiles.length) {
			// updatedAttachment([...files], attachmentType)
			updatedAttachment(lastAddedFiles, attachmentType);
		}
	}, [lastAddedFiles]);

	const removeFile = async (id) => {
		await setFiles((files) => []);
		const updatedFiles = files.filter((f) => f.id !== id);
		setFiles((files) => [...updatedFiles]);
		// updatedAttachment([...updatedFiles], attachmentType)
		deleteAttachment(
			files.filter((f) => f.id === id),
			attachmentType
		);
	};

	const onImageSelected = (e) => {
		const reader = new FileReader();
		setFileName(e.target.files[0]);
		reader.readAsDataURL(e.target.files[0]);
		reader.onload = function (e) {
			setImageCrop(reader.result);
			setCropModal(true);
		};
	};

	return (
		<>
			<p
				className={
					AuthData.lang !== "ar" ? "float-left my-0" : "float-right my-0 "
				}>
				{label}
			</p>

			<FileUploadContainer>
				<UploadFileBtn type="button" onClick={handleUploadBtnClick}>
					<i className="fas fa-file-upload" />
					<span>{t(`Upload ${otherProps.multiple ? "files" : "a file"}`)}</span>
				</UploadFileBtn>
				<FormField
					type="file"
					ref={fileInputField}
					onChange={onImageSelected}
					title=""
					value=""
					{...otherProps}
				/>
			</FileUploadContainer>
			{percent > 0 && (
				<div className="progress">
					<div
						className="progress-bar progress-bar-striped"
						role="progressbar"
						style={{ width: percent + "%" }}
						aria-valuenow={`${percent}`}
						aria-valuemin="0"
						aria-valuemax="100"></div>
				</div>
			)}
			<FilePreviewContainer>
				<PreviewList>
					{files?.map((file, index) => {
						if (file?.path) {
							return (
								<PreviewContainer key={index}>
									<div>
										{file.path.substring(
											file.path.length - 3,
											file.path.length
										) === "mp4" ? (
											<video
												style={{
													display: "block",
													width: "100%",
													marginBottom: "5px",
													height: "100px",
												}}
												controls>
												<source src={file.path} type="video/mp4" />
											</video>
										) : checkType(file?.path) ? (
											<ImagePreview src={pdf} alt={`file preview ${index}`} />
										) : (
											<ImagePreview
												src={file.path}
												alt={`file preview ${index}`}
											/>
										)}

										<FileMetaData>
											{/* <span>{file.name}</span> */}
											<aside>
												{/* <span>{convertBytesToKB(file.size)} kb</span> */}
												<RemoveFileIcon
													className="fas fa-trash-alt"
													onClick={() => removeFile(file.id)}
												/>
												<ShowContent
													href={file.path}
													target="_blank"
													rel="noopener noreferrer">
													<RemoveFileIcon className="fas fa-eye" />
												</ShowContent>
											</aside>
										</FileMetaData>
									</div>
								</PreviewContainer>
							);
						}
					})}
				</PreviewList>
			</FilePreviewContainer>
			{cropModal && (
				<CropImg
					modal={cropModal}
					toggle={toggleCrop}
					img={imageCrop}
					fileName={fileName}
					loadingCrop={loadingCrop}
					ratio={{ x: ratio.x, y: ratio.y }}
					handleNewFileUpload={handleNewFileUpload}
				/>
			)}
		</>
	);
};

export default withTranslation()(FileUpload);
